import plugin from 'tailwindcss/plugin';

const heroItem = plugin.withOptions(function () {
	return function ({ addComponents, theme, e }) {
		const borderRadius = `var(--hero-item-image-border-radius, ${theme('borderRadius.none')})`;

		addComponents({
			[`.${e('hero-item-image')}`]: {
				borderBottomLeftRadius: borderRadius,
				borderBottomRightRadius: borderRadius,
			},
		});
		addComponents({
			[`.${e('hero-item-image-shadow')}`]: {
				borderBottomLeftRadius: borderRadius,
				borderBottomRightRadius: borderRadius,
			},
		});
	};
});

export default heroItem;
